/**
 * ComparePlansDialog — plan-comparison modal.
 *
 * Thin wrapper over the shared ThemedDialog `sheet` variant (full-screen on
 * mobile, centered ≤1180px panel on desktop with a blurred backdrop). Kept as a
 * named component so the URL-driven ComparePlansOverlay reads clearly and its
 * test stays stable; all the shell concerns (z-index, RTL centering, dark
 * surface, Close affordance) live once in ThemedDialog.
 *
 * @layer-1 — themed wrapper
 */
import type { ReactNode } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/shared/components/ThemedDialog";

interface ComparePlansDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Accessible dialog title (rendered visually hidden — content has its own heading). */
  title: string;
  className?: string;
  children: ReactNode;
}

export function ComparePlansDialog({ open, onOpenChange, title, className, children }: ComparePlansDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {/* aria-describedby={undefined}: the panel has no separate description node. */}
      <DialogContent variant="sheet" aria-describedby={undefined} className={className}>
        <DialogTitle className="sr-only">{title}</DialogTitle>
        <div className="px-6 py-12 sm:px-8 sm:py-10">{children}</div>
      </DialogContent>
    </Dialog>
  );
}
